<div class="flex gap-1">
  <p-button icon="true"
            severity="contrast"
            rounded="true"
            styleClass="!size-[1.75rem] !px-0 !py-0 !bg-transparent !text-(--p-primary-200) hover:!text-(--p-primary-500) focus:!text-(--p-primary-500) !border-0"
            [text]="true"
            (mousedown)="$event.stopPropagation()"
            (click)="service.minimize(popup().id)"
            [pTooltip]="'@@floating-popup-minimize' | translate"
            tooltipPosition="bottom"
            tooltipStyleClass="text-[0.75rem] !z-app-overlay-0">
    <svg-icon src="icons/icon-minimize.svg" name="icon-minimize"></svg-icon>
  </p-button>

    <p-button icon="true"
            severity="contrast"
            rounded="true"
            styleClass="!size-[1.75rem] !px-0 !py-0 !bg-transparent !text-(--p-primary-200) hover:!text-(--p-primary-500) focus:!text-(--p-primary-500) !border-0"
            [text]="true"
            (mousedown)="$event.stopPropagation()"
            (click)="service.close(popup().id)"
            [pTooltip]="'@@shared-close' | translate"
            tooltipPosition="bottom"
            tooltipStyleClass="text-[0.75rem] !z-app-overlay-0">
    <svg-icon src="icons/icon-close-popup.svg" name="icon-close-popup"></svg-icon>
  </p-button>
</div>
